export const REQUEST_ORDER_DETAILS = 'REQUEST_ORDER_DETAILS';
export const REQUEST_ORDER_DETAILS_FAILURE = 'REQUEST_ORDER_DETAILS_FAILURE';
export const REQUEST_ORDER_DETAILS_SUCCESS = 'REQUEST_ORDER_DETAILS_SUCCESS';

export const REQUEST_ORDER_DETAIL = 'REQUEST_ORDER_DETAIL';
export const REQUEST_ORDER_DETAIL_FAILURE = 'REQUEST_ORDER_DETAIL_FAILURE';
export const REQUEST_ORDER_DETAIL_SUCCESS = 'REQUEST_ORDER_DETAIL_SUCCESS';

export const REQUEST_ADD_ORDER_DETAIL = 'REQUEST_ADD_ORDER_DETAIL';
export const REQUEST_ADD_ORDER_DETAIL_SUCCESS = 'REQUEST_ADD_ORDER_DETAIL_SUCCESS';
export const REQUEST_ADD_ORDER_DETAIL_FAILURE = 'REQUEST_ADD_ORDER_DETAIL_FAILURE';

export const REQUEST_DELETE_ORDER_DETAIL = 'REQUEST_DELETE_ORDER_DETAIL';
export const REQUEST_DELETE_ORDER_DETAIL_SUCCESS = 'REQUEST_DELETE_ORDER_DETAIL_SUCCESS';
export const REQUEST_DELETE_ORDER_DETAIL_FAILURE = 'REQUEST_DELETE_ORDER_DETAIL_FAILURE';